import { api } from '../createApi';
import { TagType } from '../TagType';

const TAG_BY_LIST = { type: TagType.ClauseLibraryV2, id: 'LIST' };

api.enhanceEndpoints({
  addTagTypes: [TagType.ClauseLibraryV2 as TagType],
  endpoints: {
    getClauseTypes: {
      providesTags: [TAG_BY_LIST],
    },
  },
});
